<div class="">
  <form
    [formGroup]="teamsForm"
    (ngSubmit)="onSubmit()"
    autocomplete="off"
    novalidate
  >
    <div class="re-agent-assign" *ngIf="leadMessageShow" role="alert">
      Lead Reassignment Completed
      <img
        src="assets/images/cancel-active.svg"
        (click)="closeMessage()"
        class="re-agent-close-lead"
      />
    </div>
    <div class="form-group">
      <label class="labels">
        Assignment Type
        <a class="re-learn" (click)="learnMoreShow()"> Learn more </a>
      </label>
      <div class="re-radiolist" id="radiobtnlist2" style="display: block">
        <label class="re-radiobtn">
          Round Robin
          <input
            type="radio"
            name="userType"
            formControlName="assignmentMethod"
            (change)="checkForUpgrade($event)"
            value="1"
          />
          <span class="re-checkmark"></span>
        </label>
        <label class="re-radiobtn">
          First to Claim
          <input
            type="radio"
            name="userType"
            formControlName="assignmentMethod"
            (change)="checkForUpgrade($event)"
            value="2"
          />
          <span class="re-checkmark"></span>
        </label>
        <label class="re-radiobtn">
          Manual Assignment
          <input
            type="radio"
            name="userType"
            formControlName="assignmentMethod"
            (change)="checkForUpgrade($event)"
            value="3"
          />
          <span class="re-checkmark"></span>
        </label>
      </div>
    </div>

    <hr />
    <div class="re-agent-block" *ngIf="currentRoleCount === 0">
      There is no lead created for this campaign. Team will be displayed once
      lead is created with this campaign.
    </div>
    <div *ngFor="let item of rolesModifiedArray">
      <div class="re-agent-tasks-cont">
        <div *ngIf="item?.roleName != 'undefined'">
          <div class="re-agent-tasktitle">
            <a
              href="javascript:void(0)"
              (click)="toggleSection(item?.roleName)"
            >
              <span class="re-agent-name-txt">{{ item?.displayName }}</span>
              <span class="re-agent-arrows" *ngIf="!isVisible(item?.roleName)">
                <i
                  class="fa fa-chevron-circle-up re-agent-teals"
                  aria-hidden="true"
                ></i>
              </span>
              <span class="re-agent-arrows" *ngIf="isVisible(item?.roleName)">
                <i
                  class="fa fa-chevron-circle-down re-agent-blacks"
                  aria-hidden="true"
                >
                </i>
              </span>
            </a>
          </div>

          <div class="row pb-3" [class.collapse]="isVisible(item?.roleName)">
            <ng-container
              *ngFor="let data of item?.row | keyvalue; let userIndex = index"
            >
              <div
                [ngClass]="userIndex == 0 ? 'row col-12' : 'row col-12 pt-5'"
              >
                <div class="col-12 col-md-3">
                  <p
                    class="re-agent-txts1 re-unassigned"
                    *ngIf="data.key == 'null'"
                  >
                    Unassigned
                  </p>
                  <p class="re-agent-txts1" *ngIf="data.key != 'null'">
                    {{ getUserName(data?.key) }}
                  </p>
                  <p class="re-agent-txts2">
                    {{ countAssignedLeads(data?.value) }} Leads Assigned
                  </p>
                </div>

                <div class="col-md-5">
                  <div
                    class="mb-2"
                    *ngFor="
                      let status of $any(data?.value);
                      let userStatusIndex = index
                    "
                  >
                    <div
                      class="re-checkboxlist"
                      id=""
                      style="display: block"
                      *ngIf="status?.count"
                    >
                      <label class="re-checkboxbtn re-agent-title">
                        <input
                          type="checkbox"
                          value="{{
                            item?.roleName +
                              '_' +
                              userIndex +
                              '_' +
                              userStatusIndex
                          }}"
                          (change)="
                            handleCheck(
                              data?.key,
                              status?.mainStatusId,
                              status?.count,
                              item?.roleName,
                              $event,
                              userIndex
                            )
                          "
                        />
                        {{ getMainStatusTitle(status?.mainStatusId) }} ({{
                          status?.count
                        }})
                        <span class="re-checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>

                <div
                  class="col-12 col-md-4 re-bord-left pt-2"
                  [class.re-agent-btn-disable]="
                    chekboxBtn(
                      data?.key + '_' + item?.roleName + '_' + userIndex
                    )
                  "
                  *ngIf="data.key != 'null' && checkCount(data?.value)"
                >
                  <a
                    href="javascript:void(0);"
                    data-toggle="modal"
                    class="re-agent-btn-reassign"
                    *ngIf="
                      isReassignAvailable(
                        data?.key,
                        item?.roleName + '_' + userIndex
                      )
                    "
                    (click)="
                      openReAssignPopUp(
                        data?.key,
                        item?.roleName + '_' + userIndex
                      )
                    "
                  >
                    Reassign
                  </a>

                  <a
                    href="javascript:void(0);"
                    data-toggle="modal"
                    class="re-agent-btn-unassign"
                    (click)="
                      openUnAssignPopUp(
                        data?.key,
                        item?.roleName + '_' + userIndex
                      )
                    "
                  >
                    Unassign
                  </a>
                </div>

                <div
                  class="col-12 col-md-4 re-bord-left pt-2"
                  *ngIf="data.key == 'null'"
                >
                  <a
                    href="javascript:void(0);"
                    data-toggle="modal"
                    class="re-agent-btn-reassign"
                    (click)="
                      openAssignTeamMemberPopUp(
                        data?.key,
                        item?.roleName + '_' + userIndex
                      )
                    "
                  >
                    Assign Team Member
                  </a>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
